// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__2az3W","marketplaceStroke":"IconEmailAttention_marketplaceStroke__CUo_j","attentionStroke":"IconEmailAttention_attentionStroke__3eZ_3"};